import { BarDataItem, TooltipData } from '@/Components/Partials/Charts/Bars/types';

export const createTooltipDataDefault = (data: BarDataItem): TooltipData => ({ title: data.label, value: data.value });
